import { io } from 'socket.io-client'

import store from '../appRedux/store'

export class Socket {
  #connections = new Map()

  #getUrlAndPath(namespace = 'base') {
    const baseUrl = new URL(process.env.REACT_APP_API_URL || '')
    const { protocol, hostname, port, pathname } = baseUrl

    let url = `${protocol}//${hostname}${port ? `:${port}` : ''}`
    if (namespace !== 'base') {
      url += `/${namespace}`
    }

    const apiPath = pathname.replace('/api/', '').replace('/api', '')
    const eventsPath = '/events'
    const path = `${apiPath}${eventsPath}`

    return { url, path }
  }

  #createConnection(namespace) {
    const { auth } = store.getState()
    const { id, token } = auth.auth

    const { url, path } = this.#getUrlAndPath(namespace)

    return new Promise((resolve, reject) => {
      const connection = io(url, {
        path,
        transports: ['polling'],
        upgrade: false,
        auth: { token },
        query: { userId: id },
        requestTimeout: 19000,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 2500
      })
      connection.connect()

      this.#connections.set(namespace, connection)

      connection.on('connect', () => {
        resolve(connection)
      })

      connection.on('connect_error', (err) => {
        reject(err)
      })
    })
  }

  async getConnection(namespace = 'base') {
    const connection = this.#connections.get(namespace) || (await this.#createConnection(namespace))
    if (connection && !connection.connected) {
      connection.connect()
      await new Promise((resolve) => connection.once('connect', resolve))
    }

    return connection
  }

  async startConnection(namespace = 'base') {
    const connection = this.#connections.get(namespace)
    if (!connection) {
      this.#createConnection(namespace)
    } else {
      connection.connect()
    }
  }

  stopConnection(namespace = 'base') {
    const connection = this.#connections.get(namespace)
    if (connection) {
      connection.disconnect()
      this.#connections.delete(namespace)
    }
  }
}

export default new Socket()
